import React from 'react';
import cn from 'classnames';
import Icon from 'src/components/HTKit/Icon';
import { ModalV2 as Modal, useModalToggle } from 'src/components/HTKit/Modals/ModalV2';
import { addBusinessDays } from 'src/containers/ProductPage/utils';

import styles from './styles.scss';

const ProductHeaderFeatures = () => {
  const estimatedDelivery = addBusinessDays();
  const { isVisible, toggle } = useModalToggle();

  return (
    <div className={styles.productInstallation}>
      <div className="flex alignItemsCenter">
        <p className="p2 successGreen500 text-weight-bold">FREE SHIPPING &amp; RETURNS</p>
        <Icon
          name="info-outline"
          className={cn('paddingLeft-tiny', styles.infoIcon)}
          onClick={toggle}
        />
      </div>
      <div className={cn('text-align-left paddingTop-tiny flex alignItemsCenter')}>
        <caption className="caption n900">Estimated Delivery</caption>
        <caption className="caption text-weight-med paddingLeft-tiny">{estimatedDelivery}</caption>
      </div>
      <Modal isVisible={isVisible} hide={toggle} header="Shipping &amp; Returns">
        <p className="p2">We offer free shipping nationwide, delivery in 1-5 days</p>
        <p className="p2 paddingTop-small1">
          If you’re not satisfied with your purchase for any reason, contact HelloTech within 30
          days of delivery to obtain a pre-paid return shipping label.
        </p>
        <p className="p2 paddingTop-small1">
          <a
            href="https://content.hellotech.com/shipping-returns-policy"
            rel="noopener noreferrer"
            target="_blank"
          >
            Details
          </a>
        </p>
      </Modal>
    </div>
  );
};

export default ProductHeaderFeatures;
